import request from "../helpers/request";

const deleteCalendarEvent = async (eventId, dataPlaceholder = null) => {
  return await request.delete(
    `/Request/drop_task/${eventId}`,
    {},
    'Не удалось удалить событие из календаря',
    dataPlaceholder
  );
};

export default deleteCalendarEvent;